import { Button, Form, Input, Modal, message } from 'antd';
import React, { FunctionComponent } from 'react';

import {
  useChangeUserAttributeMutation,
  useUpdateStudentToVmsMutation,
} from '@services/data-access';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface ChangeEmailPopupProps {
  userId: string;
  visible: boolean;
  onClose: () => void;
  role?: string;
  handleUnChange?: (value: boolean) => void;
  onSubmitPopUp?: (value: object) => void;
}

export interface ChangeEmailFormValues {
  email: string;
}

export const ChangeEmailPopup: FunctionComponent<ChangeEmailPopupProps> = ({
  userId,
  visible,
  onClose,
  role,
  handleUnChange,
  onSubmitPopUp,
}) => {
  const [form] = Form.useForm();

  const [updateStudentToVms] = useUpdateStudentToVmsMutation({
    onCompleted: (data: any) => {},
    onError: (error: any) => {},
  });

  const [changeUserAttributeMutation, { loading }] =
    useChangeUserAttributeMutation({
      onError: () => {},
      onCompleted: () => {
        const { email } = form.getFieldsValue(['email']);
        if (onSubmitPopUp) {
          onSubmitPopUp({ email });
        }
        message.success('Email changed successfully.');
        closePopup();
      },
    });

  const submitForm = (value: ChangeEmailFormValues) => {
    if (handleUnChange) {
      handleUnChange(false);
    }
    changeUserAttributeMutation({
      variables: {
        form: {
          id: userId,
          attributeName: 'email',
          forceChange: true,
          attributeValue: value.email,
        },
      },
    }).then((data: any) => {
      updateStudentToVms({
        variables: { userId },
      });
    });
  };

  const resetForm = () => {
    form.resetFields();
  };

  const closePopup = () => {
    resetForm();
    onClose();
    if (handleUnChange) {
      handleUnChange(false);
    }
  };

  return (
    <Modal
      forceRender
      centered
      title="Change Email"
      visible={visible}
      onOk={closePopup}
      onCancel={closePopup}
      footer={[
        <Button
          className="fixed-width-btn button-black-text"
          key="back"
          onClick={closePopup}
        >
          Cancel
        </Button>,
        <Button
          loading={loading}
          className="fixed-width-btn"
          key="submit"
          type="primary"
          onClick={() => {
            form
              .validateFields()
              .then(values => {
                submitForm(values as ChangeEmailFormValues);
              })
              .catch(info => {
                console.log('Validate Failed:', info);
              });
          }}
        >
          Save
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="New Email"
          name="email"
          rules={[
            {
              required: true,
              message: 'Please fill in new email!',
            },
            {
              type: 'email',
              message: 'Invalid email',
            },
          ]}
        >
          <Input
            placeholder="yournewemail@indigo.com.sg"
            prefix={<FontAwesomeIcon icon={['far', 'envelope']} />}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
